import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IIncidentCodesByGroup, IncidentCodeService } from '@shared/services/incident-code-service';
import { EmployeeService, IMesUser } from '@shared/services/mesuser.service';
import { IItemOperation } from '@shared/services/production-data.service';
import { TerminalAdministrationService } from '@shared/services/terminalAdministration.service';
import { forkJoin, take } from 'rxjs';

@Component({
	selector: 'app-mes-production-terminal-tab-dialog',
	templateUrl: './mes-production-terminal-tab-dialog.component.html',
	styleUrl: './mes-production-terminal-tab-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class MesProductionTerminalTabDialogueComponent implements OnInit {
	public noteOnly: boolean;
	public employees: IMesUser[];
	public incidentCodesByGroup: IIncidentCodesByGroup[];

	constructor(
		@Inject(MAT_DIALOG_DATA) public itemOperation: IItemOperation,
		private employeeService: EmployeeService,
		private incidentCodeService: IncidentCodeService,
		private terminalService: TerminalAdministrationService,
	) {
		this.noteOnly = !itemOperation.items.some((e) => e.ready);
	}

	ngOnInit(): void {
		this.loadSharedData();
	}

	private loadSharedData(): void {
		forkJoin({
			employees: this.employeeService.getEmployees().pipe(take(1)),
			incidentCodes: this.incidentCodeService.getAll().pipe(take(1)),
			terminal: this.terminalService.getTerminalById(this.itemOperation.terminalId).pipe(take(1)),
		}).subscribe(({ employees, incidentCodes, terminal }) => {
			this.employees = employees.result.filter((e) => e.isActive);
			this.incidentCodesByGroup = this.incidentCodeService.filterIncidentCodesByGroups(incidentCodes, terminal.incidentCodeGroups);
		});
	}
}
